const ERROR_TEXT_ID_TAG = "_error_help_text";
const HELP_TEXT_ID_TAG = "_help_text";

export default { ERROR_TEXT_ID_TAG, HELP_TEXT_ID_TAG };
